module.exports = (window.__NEXT_DATA__.assetPrefix || "").replace(/\/$/, "") + "/_next/static/images/500-page-tape-2-75163fae35d083a796465a5631ea89c7.png";